module.exports = __webpack_public_path__ + "static/media/underline.16e4052e.svg";